import { createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../api';

export const clientThunk = createAsyncThunk('client', async (id: string) => {
  return Api.get(`/client/${id}`);
});
